import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { DeviceSyncStatus } from '@rocksoft/apple-sync-sdk';

export function selectDeviceSyncStatusId(status: DeviceSyncStatus): string {
  return status.udid;
}

export const adapter: EntityAdapter<DeviceSyncStatus> = createEntityAdapter<DeviceSyncStatus>({
  selectId: selectDeviceSyncStatusId,
});

export type DeviceSyncStatusState = EntityState<DeviceSyncStatus>;

export const initialState: DeviceSyncStatusState = adapter.getInitialState();
